import { ERouteDisclaimerMessage } from '../../validators/enums';
import { ValidatorState } from '../../validators/types';
import { appIsActive, widgetIsActive } from '../../validators/utils';

export function freeCoinsValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid = appIsActive() || widgetIsActive();

  if (!isValid) {
    disclaimersKeys.push(ERouteDisclaimerMessage.FREE_COINS_RESTRICTION);
  }

  return {
    isValid,
    disclaimersKeys
  };
}
